// extracted by mini-css-extract-plugin
export var formats = "CameraAccessoryTeaserElement-module--formats--5037f";
export var infoText = "CameraAccessoryTeaserElement-module--infoText--ef22a";
export var price = "CameraAccessoryTeaserElement-module--price--7db8e";
export var priceLink = "CameraAccessoryTeaserElement-module--priceLink--5e087";
export var title = "CameraAccessoryTeaserElement-module--title--2dee1";
export var type = "CameraAccessoryTeaserElement-module--type--5bf2a";